<template>
    <div class="side-container auth-page">
        <div class="login-bg"></div>
        <div class="login-block">
            <div class="left-side">
                <div class="left-bg">
                    <div class="logo-wrapper">
                        <div class="logo">
                            <img src="@/assets/login/ans_logo_lite.png" alt="logo">
                            <span>{{$t('login.LOGIN_ROW1')}}</span>
                            <span>{{$t('login.LOGIN_ROW2')}}</span>
                            <span>{{$t('login.LOGIN_ROW3')}}</span>
                        </div>
                    </div>
                    <div class="footer-year">
                        <span>© 2020 {{$t('login.LOGIN_COPYRIGHT')}}</span>
                    </div>
                </div>
            </div>
            <div class="right-side">
                <div class="auth-block-wrapper">
                    <Login
                    :services="services"
                    :form="form"
                    :registration="registration"
                    />
                </div>
            </div>
            <ErrorPopup 
            :show="hasError" 
            :popup_header="$t('login.POPUP_FAIL_HEADER')" 
            :popup_description="loginError" 
            v-on:closeEvent="hasError=false"
            :buttons="errorButtons"
            />
        </div>
    </div>
</template>

<script>
    import CheckBox from '@/components/checkbox/CheckBox.vue'
    import lStorage from '@/store/localStorage.js';
    import env from '@/enviroment';
    import LoadingIndicator from '@/components/LoadingIndicator/LoadingIndicator';
    import enviroment from "@/enviroment";
    import i18n from "@/i18n";
    import {rest} from '@/utils/utils';
    import Login from "@/views/pages/auth/Login";
    import ErrorPopup from "@/views/pages/manager_popups/ErrorPopup";

    export default {
        name: 'AuthPage',
        components: {
            CheckBox,
            LoadingIndicator,
            Login,
            ErrorPopup
        },
        data: function() {
            return {
                loading: false,
                services:{
                    form:enviroment.auth.service.indexOf("form")>-1,
                    facebook:enviroment.auth.service.indexOf("facebook")>-1,
                    google:enviroment.auth.service.indexOf("google")>-1,
                },
                registration: {
                    allow:enviroment.auth.registration == true,
                    required:enviroment.auth.required
                },
                form:{
                    login: '',
                    email:"",
                    password: '',
                    phone:'',
                    error: '',
                    first_name:"",
                    last_name:"",
                    birthday:""
                },
                hasError:false,
                loginError:"",
                errorButtons:[]
            }
        },
        watch: {
            'form.login': function (val, oldVal) {
                this.form.error = '';
            },
            'form.password': function (val, oldVal) {
                this.form.error = '';
            }
        },
        methods: {
            /**
             * Открывает окно чата
             */
            VerboxSupportOpen(){
                Verbox("openSupport");
            },
            /**
             * Открывает окно отзывов
             */
            VerboxFeedBackOpen(){
                Verbox("openReviewsTab");
            },
            loginFB:function(){
                window.location = env.URL + '/index.php?entryPoint=client_auth&provider=facebook&action=login&deal_id='+(this.$route.query.elev_id || "")+"&language="+i18n.locale;
            },
            loginGoogle: function () {
                window.location = env.URL + '/index.php?entryPoint=client_auth&provider=facebook&action=login&deal_id='+(this.$route.query.elev_id || "")+"&language="+i18n.locale;
            }
        },
        mounted(){
            this.hasError = false;
            if(this.$route.query.error_code){
                this.loginError = i18n.t("soap."+this.$route.query.error_code,{
                    link:env.homepage
                });
                switch(parseInt(this.$route.query.error_code)){
                    case 411:
                        this.errorButtons.push({
                            label:i18n.t("login.LBL_BTN_REGISTER"),
                            class:{"primary":true},
                            action:()=>{
                                window.location.href = env.homepage;
                            }
                        });
                    break;
                }
                this.hasError = true;
            }
        },
        computed:{
        }
    }
</script>

<style lang="scss" scoped>
    .auth-page{
        width: 100%;
        height: 100%;
        position: relative;
        .login-block{
            z-index: 2;
        }
        .login-bg{
            position: fixed;
            top: 0;
            left: 0;
            bottom: 0;
            width: 50%;
            background-image: url("../../../assets/login/left_side.jpg");
            background-size: cover;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
        .left-bg {
            position: fixed;
            top: 0;
            left: 0;
            bottom: 0;
            width: 50%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }

        .logo-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;

            .logo {
                display: flex;
                flex-direction: column;

                img {
                    width: 200px;
                    height: auto;
                    padding-bottom: 2rem;
                }

                span {
                    font-family: FuturaPT;
                    font-size: 3.75rem;
                    line-height: 4rem;
                    letter-spacing: 1px;
                    color: #FFFFFF;
                }
            }
        }

        .auth-block-wrapper {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            width: 50%;
            display: flex;
            justify-content: center;
            align-items: center;

            .auth-block {
                display: flex;
                flex-direction: column;

                .auth-block-header {
                    font-family: FuturaPT;
                    font-size: 43px;
                    line-height: 52px;
                    letter-spacing: 1px;
                    color: #0B1022;
                    margin: 0;
                }

                .auth-block-text {
                    font-family: FuturaPT;
                    font-style: normal;
                    font-weight: 500;
                    font-size: 21px;
                    line-height: 28px;
                    letter-spacing: 0.5px;
                    color: rgba(11, 16, 34, 0.3);
                    padding-bottom: 26px;
                }

                .is-save-auth-wrapper {
                    display: flex;
                    align-items: center;
                    padding-top: 2.0rem;
                    padding-left: 1.5rem;

                    span {
                        font-family: FuturaPT;
                        font-style: normal;
                        font-weight: 500;
                        font-size: 1.6rem;
                        line-height: 2.1rem;
                        text-align: center;
                        letter-spacing: 0.5px;
                        color: rgba(11, 16, 34, 0.3);
                        padding-left: 1rem;
                    }
                }
            }
        }
        
        .form-field{
            width: 100%;
            margin-bottom: 10px;
            &>label{
                font-family: 'FuturaPT';
                font-size: 20px;
                .required{
                    color:#f44336;
                }
            }
            .input-wrapper{
                margin-top:5px;
                input{
                    font-family: 'FuturaPT';
                    color: #263238;
                    &::placeholder{
                        color:#b5b7bc;
                    }
                }
            }
        }
        .footer-year {
            display: flex;
            justify-content: center;
            padding-bottom: 3.5rem;
            position: absolute;
            bottom: 20px;
            span {
                font-family: FuturaPT;
                font-style: normal;
                font-weight: 500;
                font-size: 1.8rem;
                line-height: 2.1rem;
                letter-spacing: 0.05rem;
                color: #FFFFFF;
            }
        }
    }
</style>